"use client";
import React, { useState, useEffect } from "react";
import Link from "next/link";
import Image, { StaticImageData } from "next/image";
import logoMarketingLand from "@/app/images/logo-marketing-land.png";
import logoEnterpreneur from "@/app/images/logo-entrepreneur.png";
import logoWordstream from "@/app/images/logo-wordstream.png";
import logoNeilPatel from "@/app/images/logo-nailpatel.svg";
import logoSearchEngineWatch from "@/app/images/logo-searchenginewatch.jpg";
import { avenirNextRegular, fontAwesome } from "@/styles/fonts";

function CarouselItem(props: {
    imageSrc: StaticImageData;
    alt: string;
    name: string;
    title: string;
    href: string;
}) {
    return (
        <div className={`p-5 h-[100%] mb-[10px] 
        text-left bg-white rounded-[6px] 
        shadow-[1px_2px_3px_rgba(0,0,0,0.1)] 
        w-full
        ${avenirNextRegular.className}`}>
            <Image src={props.imageSrc}
                className="mb-3 md:mb-8"
                alt={props.alt} />
            <h1 className="
            text-[18px]
            sm:text-[20px]
            text-[#343f50] 
            mb-[10px] md:mb-[20px]">{props.name}</h1>
            <p className="static-content 
            text-[#5e6977] 
            text-sm
            sm:text-[16px]
            lg:text-[20px]
            lg:leading-[25px]
            mb-3
            pb-3
             border-b border-[#e1e8ee]">{props.title}</p>
            <Link className="text-[#0086b9]
            text-sm" target="_blank" href={props.href}>
                Read More <span className={`${fontAwesome.className} text-[12px]`} aria-hidden="true"></span>
            </Link>
        </div>
    );
}

export default function AboutUsCarousel() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsPerView, setItemsPerView] = useState(2);

    const items = [
        {
            imageSrc: logoMarketingLand,
            alt: "Marketing Land",
            name: "Tools For Spying On Your Competitor’s Display Ads",
            title: "Just go ahead and admit it. We’ve all had a fascination with spies since we were kids. That’s why we flock to spy movies like Mission...",
            href: "http://marketingland.com/tools-for-spying-on-your-competitors-display-ads-19514",
        },
        {
            imageSrc: logoEnterpreneur,
            alt: "Entrepreneur",
            name: "37 Best Marketing Tools to Spy on Your Competitors",
            title: "Adbeat is an enterprise tool that lets you see all of the ads that particular advertisers are using, split test their ad copy to help you with strategy...",
            href: "https://www.entrepreneur.com/article/229350",
        },
        {
            imageSrc: logoWordstream,
            alt: "Wordstream",
            name: "7 Niche Marketing Ideas for Specialized Businesses",
            title: "For businesses in niche markets, it’s vital to know what your competitors are up to. Fortunately, you don’t need to resort to corporate espionage...",
            href: "http://www.wordstream.com/blog/ws/2014/10/28/niche-marketing?dt=1",
        },
        {
            imageSrc: logoNeilPatel,
            alt: "Neil Patel",
            name: "Comparing the ROI of Content Marketing and Paid Advertising",
            title: "Is there any rule that says you shouldn’t invest money in paid channel advertising as opposed to a content marketing ROI strategy? I don’t think so.",
            href: "https://neilpatel.com/blog/comparing-the-roi-of-content-marketing-and-paid-advertising/",
        },
        {
            imageSrc: logoSearchEngineWatch,
            alt: "Search Engine Watch",
            name: "18 Must-Have Paid Tools for PPC Success",
            title: "In PPC, or for tougher tasks like landing page optimization, paid tools are necessary to make an impact, and they usually pay for themselves...",
            href: "https://searchenginewatch.com/sew/how-to/2338594/18-must-have-paid-tools-for-ppc-success",
        },
    ];

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? items.length - itemsPerView : prevIndex - 1
        );
    };

    const handleNext = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === items.length - itemsPerView ? 0 : prevIndex + 1
        );
    };

    const updateItemsPerView = () => {
        if (window.innerWidth >= 1024) {
            setItemsPerView(3); 
        } else if (window.innerWidth >= 640) {
            setItemsPerView(2);
        } else {
            setItemsPerView(1); 
        }
    };

    useEffect(() => {
        updateItemsPerView();
        window.addEventListener("resize", updateItemsPerView);
        return () => window.removeEventListener("resize", updateItemsPerView);
    }, []);

    const shownItems = items.slice(currentIndex, currentIndex + itemsPerView);

    return (
        <div className="relative overflow-hidden px-[20px]">
            <div
                className="flex justify-center items-stretch gap-[50px]">
                {shownItems.map((item, index) => (
                    <div
                        key={index}
                        // className="flex-shrink-0"
                        style={{ width: `calc(${100 / itemsPerView}% - 50px)` }}
                    >
                        <CarouselItem {...item} />
                    </div>
                ))}
            </div>
            <button
                className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-200 p-2 rounded-full"
                onClick={handlePrev}
            >
                <span className={`${fontAwesome.className}`} aria-hidden="true">
                    
                </span>
            </button>
            <button
                className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-200 p-2 rounded-full"
                onClick={handleNext}
            >
                <span className={`${fontAwesome.className}`} aria-hidden="true">
                    
                </span>
            </button>
        </div>
    );
}